import React, {useState} from 'react';
import FormInput from "../FormInput/FormInput";
import PropTypes from 'prop-types';
import './LiveSearchInput.sass'

LiveSearchInput.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func,
    id: PropTypes.string,
    title: PropTypes.any,
    name: PropTypes.string,
    reff: PropTypes.any,
    storage: PropTypes.array,
    optionClickHandler: PropTypes.func
};

function LiveSearchInput(props) {
    const [helperShow, setHelperShow] = useState();

    return (
        <div className={'live-Search'}>
            <FormInput
                name={props.name}
                title={props.title}
                id={props.id}
                reff={props.reff}
                onChange={props.onChange}
                className={`live-Search__input ${props.className}`}
                hideIcon={true}
                value={props.value}
                onFocus={_ => setHelperShow(true)}
                onBlur={_ => setTimeout(() => setHelperShow(false), 200)}
            />

            {helperShow ? <div className={'live-Search__Dropdown-Helper'}>
                {props.storage ? props.storage.map(item => {
                    return <div onClick={_ => props.optionClickHandler(item.data.kpp, item.data.inn)} key={item.data.kpp + item.data.inn} id={item.data.kpp}
                                className="live-Search__Dropdown-Helper__option">{item.data.name.full}</div>
                }) : ''}
            </div> : ''}
        </div>
    );
}

export default LiveSearchInput;
